import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
function StatusAPI() {
const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const [ShowHideAccordionThree, SetShowHideAccordionThree] = useState(false);
const [ShowHideAccordionFour, SetShowHideAccordionFour] = useState(false);
const onClickAccordianShowHideOne = () => {
SetShowHideAccordionOne(!ShowHideAccordionOne)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const onClickAccordianShowHideThree = () => {
SetShowHideAccordionThree(!ShowHideAccordionThree)
}
const onClickAccordianShowHideFour = () => {
SetShowHideAccordionFour(!ShowHideAccordionFour)
}
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Status API</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2>Status API Integration</h2>
            <p>
               This API helps you to know the updated status of the requested transactions through S2S call.<br/>
               Status Query API uses JSON format and sent using Restful Web Service.
            </p>
            <u>
               <h5>POST URL:</h5>
            </u>
            {/* <p className="mt-20"><b>Testing:</b> <span class="col-red">https://pguat.safexpay.com/agcore/api/query/post</span></p>
            <p><b>Production:</b> <span class="col-red">https://www.avantgardepayments.com/agcore/api/query/post</span></p> */}

<p className="mt-20"><b>Testing:</b> <span class="col-red" >https://uatcheckout.safexpay.com/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus</span></p>
            <p><b>Production:</b> <span class="col-red" >https://checkout.safexpay.com/ms-transaction-core-1-0/transactionStatusRedirection/defaultTransactionStatus</span></p>
            <p>All the API rquest of Safexpay runs with the code logic of <b>AES-256</b> encrypt algorithm which is mandatory in order to get the actual response from the server.</p>
            <p>The value for the <b>$iv</b> remains the same as mentioned below:</p>
            <p>
               <b>Merchant key</b> is used to encrypt and Decrypt the Request and response parameters To make the encryption logic simple and reliable please find the below encrypt and decrypt logic for your reference.
            </p>
            <p>
               <a href="assets/pdf/Status Query API.pdf"><span class="col-org"><i>Click here</i></span></a> to download our Status API documentation.
            </p>
            <u>
               <p>
                  AUTHORIZATIONS:
               </p>
            </u>
            <p className="mb-0">REQUEST BODY SCHEMA: &nbsp;<span style={{ color: "#313131" }}>application/json</span></p>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator ID is “Paygate”.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant ID issued to you by AvantGarde.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Order_no in encrypted format against which you want to search for the transaction id. It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>AG_ref in encrypted format generated by the aggregator during the transaction.It should be encrypted format.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <h5 className="mt-30">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b> successfull operation {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <p class="mt-10 mb-0"><span>RESPONSE SCHEMA: </span>  &nbsp;<span style={{ color: "#313131" }}>application/json</span></p>
                     <hr class="hr-col">
                     </hr>
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr className='expanded'>
                              <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideOne}>
                                 <span className='sc-iemWCZ fhDkLh'></span>
                                 <span>
                                    txn_response {ShowHideAccordionOne ? 
                                    <FaAngleDown/>
                                    : 
                                    <FaAngleUp/>
                                    }
                                 </span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           {ShowHideAccordionOne &&
                           <tr>
                              <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                                 <div className="sc-dIvrsQ kPKTxr">
                                    <table class="sc-hHEiqL iZJLLY">
                                       <tbody>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Aggregator ID is “Paygate”.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Merchant ID issued to you by AvantGarde.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Order _no for which you have initiated payment.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Transaction Amount.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="country"><span class="sc-iemWCZ fhDkLh"></span><span>country</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>ISO country code. E.g. “IND” for India.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="currency"><span class="sc-iemWCZ fhDkLh"></span><span>currency</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>ISO currency code. E.g. “INR” for India..</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Format DD-MM-YYYY. E.g. 26-11-2015</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Format HH.MM  SS. E.g. 23:30:50.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>AG_ref id generated by the aggregator during the transaction.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>PG_ref generated by bank from which you have initiated payment.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>“Successful”, “Failed”, “Hold” or “Pending”</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Response Code. 0 for Success</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr class="last undefined">
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Text message explaining the failure reason.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </td>
                           </tr>
                           }
                           <tr className='expanded'>
                              <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                                 <span className='sc-iemWCZ fhDkLh'></span>
                                 <span>
                                    pg_details {ShowHideAccordionTwo ? 
                                    <FaAngleDown/>
                                    : 
                                    <FaAngleUp/>
                                    }
                                 </span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           {ShowHideAccordionTwo &&
                           <tr>
                              <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                                 <div className="sc-dIvrsQ kPKTxr">
                                    <table class="sc-hHEiqL iZJLLY">
                                       <tbody>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Bank Number. E.g. “1” for HDFC Bank.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Bank Name. E.g. “HDFC Bank”</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>NB = Net Banking CC = Credit Card DC = Debit Card PP = Prepaid Card WA = Wallet CE = Credit Card EMI</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr class="last undefined">
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>This is only provided if EMI is selected.            Values can be 3, 6, 9 or 12.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </td>
                           </tr>
                           }
                           <tr className='expanded'>
                              <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                                 <span className='sc-iemWCZ fhDkLh'></span>
                                 <span>
                                    fraud_details {ShowHideAccordionThree ? 
                                    <FaAngleDown/>
                                    : 
                                    <FaAngleUp/>
                                    }
                                 </span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           {ShowHideAccordionThree &&
                           <tr>
                              <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                                 <div className="sc-dIvrsQ kPKTxr">
                                    <table class="sc-hHEiqL iZJLLY">
                                       <tbody>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Only if fraud engine is selected. Accept = Fraud not suspected. Reject = Very strong fraud suspicion, reject the order. Review = Fraud suspected, review the customer details before processing the order.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Only if fraud engine is selected. Fraud       message describes the fraud in detail.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr class="last undefined">
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Only if fraud engine is selected. Number between min and max risk scale.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </td>
                           </tr>
                           }
                           <tr className='expanded last undefined'>
                              <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideFour}>
                                 <span className='sc-iemWCZ fhDkLh'></span>
                                 <span>
                                    other_details {ShowHideAccordionFour ? 
                                    <FaAngleDown/>
                                    : 
                                    <FaAngleUp/>
                                    }
                                 </span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           {ShowHideAccordionFour &&
                           <tr className='expanded'>
                              <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                                 <div className="sc-dIvrsQ kPKTxr">
                                    <table class="sc-hHEiqL iZJLLY">
                                       <tbody>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_1"><span class="sc-iemWCZ fhDkLh"></span><span>udf_1</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Same value as given in request.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_2"><span class="sc-iemWCZ fhDkLh"></span><span>udf_2</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Same value as given in request.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_3"><span class="sc-iemWCZ fhDkLh"></span><span>udf_3</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Same value as given in request.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr>
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_4"><span class="sc-iemWCZ fhDkLh"></span><span>udf_4</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Same value as given in request.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                          <tr class="last undefined">
                                             <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf_5"><span class="sc-iemWCZ fhDkLh"></span><span>udf_5</span></td>
                                             <td class="sc-bkbkJK gmOLLi">
                                                <div>
                                                   <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                   <div>
                                                      <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                         <p>Same value as given in request.</p>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </td>
                           </tr>
                           }
                        </tbody>
                     </table>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
         </div>
      </div>
      <div class="col-md-4 extreme-rt-div">
         <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                     <button> POST </button> /api/query/post  {TabCheck1 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck1 &&
            <div>
               <br />
               <div class="card-body">
                  <p class="mb-0">Production server (uses live data)</p>
                  <div class="api-div-bor">
                     <span>https://www.avantgardepayments.com</span><span
                        class="col-org">/agcore/api/query/post</span>
                  </div>
                  <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                  <div class="api-div-bor">
                     <span>https://pguat.safexpay.com</span><span
                        class="col-org">/agcore/api/query/post</span>
                  </div>
               </div>
            </div>
            }
         </div>
      </div>
      <RequestJSON/>
      <ResponseJSON/>
   </div>
</div>
</div>
</div>
)
}
export default StatusAPI